import { render, staticRenderFns } from "./PrivacyPlaceholder.vue?vue&type=template&id=0b9ecc6e"
import script from "./PrivacyPlaceholder.vue?vue&type=script&lang=js"
export * from "./PrivacyPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports